import { createContext, useContext } from "react";

const ShareSessionContext = createContext<string | null>(null);

export function ShareSessionProvider({
  sessionToken,
  children,
}: {
  sessionToken: string;
  children: React.ReactNode;
}) {
  return (
    <ShareSessionContext.Provider value={sessionToken}>
      {children}
    </ShareSessionContext.Provider>
  );
}

export function useShareSessionToken(): string | null {
  return useContext(ShareSessionContext);
}
